import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  connect() {
    Tooltip.getOrCreateInstance(this.element, { html: true })
  }

  disconnect() {
    Tooltip.getInstance(this.element)?.dispose()
  }
}
